import { ReactKit } from '@team/react';
import { Entry } from './entry';
import { Basic } from './components/basic';

export const Snackbar = ReactKit.createCompoundComponent(Entry, { Basic });

Snackbar.displayName = 'Snackbar';
Snackbar.Basic.displayName = 'SnackbarBasic';
